export const contentType = {
    "Content-Type": "application/json"
}

export interface HttpResponse {
    status: number
    headers: any
    body: any
}

export interface HttpRequestDelegate {
    (method: string, url: string, headers: any, body: any): Promise<HttpResponse>
}

export class SennoException {
    uuid: string
    code: number
    message: string
    traceUuid: string

    constructor(headers: any) {
        this.uuid = headers["senno-exception-uuid"]
        this.code = headers["senno-exception-code"]
        this.message = headers["senno-exception-message"]
        this.traceUuid = headers["senno-exception-trace-uuid"]
    }
}

export class GrpcService {
    private host: string
    private httpRequestDelegate: HttpRequestDelegate

    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        this.host = host
        this.httpRequestDelegate = httpRequestDelegate
    }

    async call(method: string = "post", path: string, request: any): Promise<any> {
        const response =  await this.httpRequestDelegate(
            method,
            this.host + path,
            contentType,
            request
        )

        if (response.status == 200) {
            return response.body
        } else {
            throw new SennoException(response.headers)
        }
    }
}
